import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { updateLeave, viewLeaves } from "../../http";
import { toast } from "react-toastify";
import Loading from "../Loading";

const Leave = () => {
  const { id } = useParams();
  const [application, setApplication] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const obj = { _id: id };
        const res = await viewLeaves(obj);
        if (res.success) {
          console.log("🔹 Refetched leave data:", res.data[0]);
          setApplication(res.data[0]);

          // Update localStorage
          localStorage.setItem(`leave_${id}`, JSON.stringify(res.data[0]));
        } else if (res.success && (!res.data || !Array.isArray(res.data) || res.data.length === 0)) {
          toast.error("No application data found.");
          console.log("🔹 Empty or invalid data structure:", res);
        } else {
          toast.error(res.message || "Failed to fetch application.");
        }
      } catch (error) {
        console.error("❌ Error fetching application:", error);
        toast.error("Error fetching application data.");
      }
    };

    fetchData();
  }, [id]); // <-- This will refetch when the `id` changes

  const handleAction = async (status) => {
    if (!application?.adminMessage?.trim()) {
      toast.error("Admin Message is required.");
      return;
    }

    if (application.adminResponse === status) {
      toast.error(`Application already ${status}`);
      return;
    }

    // Only send relevant leave data
    const leaveData = {
      adminResponse: status.charAt(0).toUpperCase() + status.slice(1),
      adminMessage: application.adminMessage.trim(),
      // Include only the necessary fields for leave update
      title: application.title,
      type: application.type,
      reason: application.reason,
      startDate: application.startDate,
      endDate: application.endDate,
      period: application.period,
      leaderResponse: application.leaderResponse,
      leaderMessage: application.leaderMessage,
    };

    try {
      console.log("🔹 Sending payload:", leaveData);

      const res = await updateLeave(id, leaveData); // API call

      console.log("🔹 API Response:", res);

      if (res.success) {
        toast.success(`Leave ${status}`);

        // Update state
        setApplication(leaveData);

        // Store in localStorage AFTER state update
        setTimeout(() => {
          localStorage.setItem(`leave_${id}`, JSON.stringify(leaveData));
          console.log("🔹 Updated in localStorage:", leaveData);
        }, 100);
      } else {
        toast.error(res.message || "Failed to update leave.");
      }
    } catch (error) {
      console.error("❌ Error updating leave:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      {application ? (
        <div className="main-content">
          <section className="section">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <h4>Application on {application?.appliedDate}</h4>
              </div>
            </div>

            <div className="col-md-9">
              <table className="table">
                <tbody>
                  <tr>
                    <th>Title</th>
                    <td>{application?.title}</td>
                  </tr>
                  <tr>
                    <th>Type</th>
                    <td>{application?.type}</td>
                  </tr>
                  <tr>
                    <th>Reason</th>
                    <td>{application?.reason}</td>
                  </tr>
                  <tr>
                    <th>Start Date</th>
                    <td>
                      {new Date(application?.startDate)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")}
                    </td>
                  </tr>
                  <tr>
                    <th>End Date</th>
                    <td>
                      {new Date(application?.endDate)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")}
                    </td>
                  </tr>
                  <tr>
                    <th>Applied Date</th>
                    <td>
                      {new Date(application?.appliedDate)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")}
                    </td>
                  </tr>
                  <tr>
                    <th>Period</th>
                    <td>{application?.period}</td>
                  </tr>
                  <tr>
                    <th>Leader Response</th>
                    <td
                      className={
                        application?.leaderResponse === "Rejected"
                          ? "text-danger"
                          : application?.leaderResponse === "Pending"
                          ? "text-danger"
                          : "text-success"
                      }>
                      {application?.leaderResponse}
                    </td>
                  </tr>
                  <tr>
                    <th>Leader Message</th>
                    <td>{application?.leaderMessage}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td
                      className={
                        application?.adminResponse?.toLowerCase() === "rejected"
                          ? "text-danger"
                          : application?.adminResponse?.toLowerCase() ===
                            "pending"
                          ? "text-danger"
                          : "text-success"
                      }>
                      {application?.adminResponse
                        ? application.adminResponse.charAt(0).toUpperCase() +
                          application.adminResponse.slice(1).toLowerCase()
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <th>Admin Message</th>
                    <td>
                      <textarea
                        className="form-control"
                        value={application?.adminMessage || ""}
                        onChange={(e) =>
                          setApplication({
                            ...application,
                            adminMessage: e.target.value,
                          })
                        }
                        placeholder="Enter message for approval or rejection"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <button
                onClick={() => handleAction("Approved")}
                className={`${
                  application?.adminResponse === "Approved"
                    ? "btn-secondary"
                    : "btn-success"
                } btn btn-lg m-4`}>
                Approve
              </button>
              <button
                onClick={() => handleAction("Rejected")}
                className={`${
                  application?.adminResponse === "Rejected"
                    ? "btn-secondary"
                    : "btn-danger"
                } btn btn-lg m-4`}>
                Reject
              </button>
            </div>
          </section>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Leave;
